﻿// Import general mixin for shared functionality.
import mixin from './mixin';
import NewsItem from './components/NewsItem.vue';
import Skeleton from './components/Skeleton.vue';

// Import axios for API consuming in a clean interface.
const axios = require('axios');

const newsApp = {
    mixins: [mixin],
    components: { NewsItem, Skeleton },
    // The data object returns data-attribute values instantiated in HTML and general properties for loading state, 
    // the data object with facets and resulting items, the view toggler for results, the current 'page' and textual search input binding.
    data() {
        return {
            dataApi: '',
            dataLimit: 9, // Default limit in BE
            dataCulture: '',

            loading: false,
            data: null,
            page: 1,
        }
    },
    // The computed object holds checks for facets set, filters chosen and filters active.
    // Furthermore, reactive properties for orderItems, filterItems and the queryModel are kept track of.
    computed: {
        itemsSet() {
            return this.data && this.data.items && this.data.items.length;
        },
        queryParams() {
            const urlParams = new URLSearchParams();
            if (this.dataCulture) urlParams.append('culture', this.dataCulture);
            if (this.dataLimit) urlParams.append('limit', this.dataLimit);
            let offset = (this.page - 1) * this.dataLimit;
            if (offset) urlParams.append('offset', offset);
            return urlParams.toString();
        },
    },
    methods: {
        // Method to be called on initialization to handle setting of data props and fetching first data loads.
        async init() {
            // Set loading to true and page to 1.
            this.loading = true;
            this.page = 1;

            // Set more data props according to data attributes in HTML template.
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.culture) this.dataCulture = this.$el.dataset.culture;

            // General data fetch.
            const generalResponse = await this.fetchData();
            this.setData(generalResponse);

            // Construct query model and alter data props based on URL search params.
            const urlParams = new URLSearchParams(window.location.search);

            let pageParam = urlParams.has('page') ? parseInt(urlParams.get('page')) : 0;
            if (pageParam) urlParams.delete('page');
            if (pageParam < 2) pageParam = 0;

            // Loop through fetch cycles if the page param is set to retrieve multiple chunks of data
            if (pageParam && pageParam > 1) {
                this.page++;
                for (this.page; this.page <= pageParam; this.page++) {
                    const response = await this.fetchData();
                    this.setData(response);
                }
                this.page--;
            }

            // Set loading to false.
            this.loading = false;
        },
        // The fetchData method fetches and handles API data, mainly facets and resulting items. 
        async fetchData() {
            try {
                const response = await axios.get(this.dataApi + '?' + this.queryParams);
                return response;
            } catch (error) {
                console.log(error)
            }
        },
        // Lazy loading data chunks handler.
        async loadMore() {
            this.page++;
            const response = await this.fetchData();
            this.setData(response);
            this.updateUrl();
        },
        // Method to set data items array or append items to it.
        setData(response) {
            if (!response || response.status != 200) return;
            if (!this.data) {
                this.data = response.data;
            }
            else {
                if (response.data.items && response.data.items.length) {
                    response.data.items.forEach(item => {
                        this.data.items.push(item);
                    })
                }
            }
        },
        // Method for updating browser URL and state history with changed filters, search input or page.
        updateUrl() {
            if (this.page === 1) {
                history.pushState({}, null, window.location.pathname);
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.page > 1) urlParams.append('page', this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
    },
    // Call init method in mounted hook.
    mounted() {
        this.init();
    },
};

export default newsApp;
